import React from 'react'

export interface StepOption {
  id: string
  name: string
}

export interface StepTargetSelectProps {
  value: string
  onChange: (stepId: string) => void
  steps: StepOption[]
  placeholder?: string
  emptyLabel?: string
  allowCustomId?: boolean
}

/**
 * Select de etapa do fluxo + campo texto opcional para ID livre.
 */
export function StepTargetSelect({
  value,
  onChange,
  steps,
  placeholder = 'ID da etapa',
  emptyLabel = '— Selecionar —',
  allowCustomId = true
}: StepTargetSelectProps) {
  const idSet = React.useMemo(() => new Set(steps.map((s) => s.id)), [steps])
  const isKnown = Boolean(value) && idSet.has(value)
  const [forceCustom, setForceCustom] = React.useState(false)

  const showCustom =
    steps.length === 0
      ? true
      : forceCustom || (Boolean(value) && !isKnown)

  React.useEffect(() => {
    if (isKnown) setForceCustom(false)
  }, [value, isKnown])

  if (steps.length === 0 && !allowCustomId) {
    return (
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
        placeholder={placeholder}
      />
    )
  }

  return (
    <div className="space-y-1">
      {!showCustom ? (
        <select
          value={isKnown ? value : ''}
          onChange={(e) => {
            const v = e.target.value
            if (v === '__custom__') {
              setForceCustom(true)
              onChange('')
              return
            }
            onChange(v)
          }}
          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm bg-white"
        >
          <option value="">{emptyLabel}</option>
          {steps.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name || s.id} ({s.id})
            </option>
          ))}
          {allowCustomId && (
            <option value="__custom__">Outro… (digitar ID da etapa)</option>
          )}
        </select>
      ) : (
        <div className="flex gap-2">
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm font-mono"
            placeholder={placeholder}
          />
          {steps.length > 0 && (
            <button
              type="button"
              onClick={() => {
                setForceCustom(false)
                if (value && !idSet.has(value)) onChange('')
              }}
              className="shrink-0 px-2 py-1 text-xs text-blue-700 border border-blue-200 rounded hover:bg-blue-50"
            >
              Lista
            </button>
          )}
        </div>
      )}
    </div>
  )
}
